(function () {

	const footer = () => {
		const footerDetails = document.querySelectorAll(
			'.footer .accordion details',
		);
		footerDetails.forEach((targetDetail) => {
			targetDetail.addEventListener('click', () => {
				footerDetails.forEach((detail) => {
					if (detail !== targetDetail) {
						detail.removeAttribute('open');
					}
				});
			});
		});

	}

	document.addEventListener('shopify:section:load', footer);
	footer();

})();
// Native validation blocks submission; show missing consent in the page as well.
(function () {
  function consentError(input) {
    return document.getElementById(input.getAttribute('aria-describedby'));
  }
  document.addEventListener('invalid', function (event) {
    const input = event.target;
    if (!input.matches('.newsletter-form input[name="newsletter_checkbox"]')) return;
    const message = consentError(input);
    if (message) message.hidden = false;
    input.setAttribute('aria-invalid', 'true');
  }, true);
  document.addEventListener('change', function (event) {
    const input = event.target;
    if (!input.matches('.newsletter-form input[name="newsletter_checkbox"]')) return;
    const message = consentError(input);
    if (input.checked) {
      if (message) message.hidden = true;
      input.removeAttribute('aria-invalid');
    }
  });
})();
